import { VideoSource } from "@/constants/media";
import { useClientConfig } from "@/context/clientConfig";
import { useImgixImageURL } from "@/hooks/useImgixImageURL";
import type { UploadedImage } from "@/types";

export function useGetVideoURL(source: VideoSource, videoId?: string) {
  const {
    coreVideo: { host },
  } = useClientConfig();

  if (!videoId) return "";

  switch (source) {
    case VideoSource.Core:
      return `${host}/${videoId}`;

    case VideoSource.Vimeo:
      return `https://player.vimeo.com/video/${videoId}`;

    case VideoSource.Wistia:
      return `https://fast.wistia.net/embed/iframe/${videoId}`;

    case VideoSource.YouTube:
      return `https://www.youtube.com/embed/${videoId}`;
  }
}

export function useGetVideoThumbnailURL(
  source: VideoSource,
  videoId?: string,
  customThumbnail?: UploadedImage,
) {
  const thumbnailURI = useImgixImageURL(customThumbnail?.path);

  if (thumbnailURI) return thumbnailURI;

  switch (source) {
    case VideoSource.YouTube:
      return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

    default:
      return "";
  }
}
